import React from 'react'

const TransferCopy = () => (
    <>
        <p>BSK Mastersound specializes in the restoration of obscure digital and analog recording formats.</p>
        <p>Say you have some recordings from a loved one on open reel tape but have no way to play them. BSK Mastersound can transfer the tapes to CD, hi-res file, or another format of your choice for easier listening.</p>
        <p>Or perhaps you have a music project produced completely digitally, but want to add the distinctive audio signature of tape. Bruce can take your tracks and run the project to tape before transferring the tape to a convenient digital file.</p>
        <p>BSK Mastersound can do transfers from LP, cassette, open reel, DTRS, and several other obscure formats. If you’re not sure, just ask! Chances are it can be done.</p>
        <p>To start your inquiry, select a category.</p>
    </>
)

export default TransferCopy
